<template>
  <Box variant="default" size="small" class="box--rounded">
    <GroupEntity v-if="Array.isArray(user)" :users="user">
      <div slot="body">
        <Icon
          :id="icon.id"
          :scale="icon.scale"
          :class="[iconClass, 'mrgr--']"
        />
        <span :title="createdAtFull">
          {{ createdAtFormatted }}
        </span>
      </div>
      <template slot="actions">
        <UserActions
          :users="user"
          :enable-emergency-call="enableEmergencyCall"
          @call-started="$emit('call-started')"
        >
          <template v-slot:post-actions>
            <slot name="post-actions" />
          </template>
        </UserActions>
      </template>
    </GroupEntity>
    <UserEntity v-else :user="user" layout="inline">
      <div slot="body">
        <Icon
          :id="icon.id"
          :scale="icon.scale"
          :class="[iconClass, 'mrgr--']"
        />
        <span :title="createdAtFull">
          {{ createdAtFormatted }}
        </span>
      </div>
      <template slot="actions">
        <UserActions
          :user="user"
          :enable-emergency-call="enableEmergencyCall"
          @call-started="$emit('call-started')"
        >
          <template v-slot:post-actions>
            <slot name="post-actions" />
          </template>
        </UserActions>
      </template>
    </UserEntity>
  </Box>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { mapGetters } from 'vuex';

import UserEntity from '@/components/users/UserEntity';
import GroupEntity from '@/components/users/GroupEntity';
import UserActions from '@/components/users/UserActions';

dayjs.extend(relativeTime);

export default {
  components: {
    UserEntity,
    GroupEntity,
    UserActions,
  },

  props: {
    conference: {
      type: Object,
      required: true,
    },
    enableEmergencyCall: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),

    createdAtFormatted() {
      return dayjs(this.conference.created_at).fromNow();
    },

    createdAtFull() {
      return dayjs(this.conference.created_at).format('D MMM YYYY HH:mm');
    },

    initiator() {
      return this.conference.invitees.find(invitee => invitee.is_initiator);
    },

    invitees() {
      return this.conference.invitees.filter(invitee => !invitee.is_initiator);
    },

    isOutgoing() {
      return this.conference.invitees.find(
        invitee => invitee.user.type === 'operator'
      ).is_initiator;
    },

    inviteesOrInitiator() {
      return this.isOutgoing ? this.invitees : this.initiator;
    },

    user() {
      if (Array.isArray(this.inviteesOrInitiator)) {
        return this.inviteesOrInitiator.map(invitee => invitee.user);
      } else {
        return this.inviteesOrInitiator.user;
      }
    },

    icon() {
      if (this.conference.state.state === 'missed') {
        return { id: 'missed-call', scale: 0.58333333 };
      } else if (this.isOutgoing) {
        return { id: 'outgoing-call', scale: 0.41666667 };
      } else {
        return { id: 'incoming-call', scale: 0.41666667 };
      }
    },

    iconClass() {
      switch (this.conference.state.state) {
        case 'failed':
        case 'missed':
        case 'ignored':
          return 'text-danger';

        default:
          return 'text-primary';
      }
    },
  },
};
</script>
